module.exports = __webpack_public_path__ + "img/punalur_hsp.862b15c9.jpg";